import { FC } from 'react';

interface ImageCreditProps {
	credit: string;
}

const ImageCredit: FC<ImageCreditProps> = ({ credit }) => {
	return (
		<div className="image-credit">
			<span className="image-credit__text">{credit}</span>
		</div>
	);
};

export default ImageCredit;
